export const common = {
  siteName: '韩漫屋',
  siteTagline: '免费韩漫大全 · 好看的韩国漫画 · 韩漫在线阅读',
  navHome: '首页',
  navCategory: '分类',
  navAbout: '关于我们',
  navSearch: '搜索漫画...',
  hotRanking: '热门排行',
  latestUpdate: '最新更新',
  viewAll: '查看全部',
  startReading: '开始阅读',
  addBookshelf: '加入书架',
  categoryTitle: '漫画分类',
  testimonialsTitle: '漫友口碑',
  ctaTitle: '开启你的韩漫之旅',
  ctaSubtitle: '海量免费韩漫资源，每日更新，随时随地畅享阅读乐趣',
  ctaButton: '立即探索',
  footerBrandDesc: '韩漫屋致力于为中文读者提供最优质的韩国漫画在线阅读体验，汇聚海量免费韩漫资源，打造温馨舒适的阅读空间。',
  footerAddress: '联系我们',
  footerAddressLine: '在线客服：hello@fkyy11.com',
  footerPhone: '商务合作',
  footerPhoneLine: '商务邮箱：hello@fkyy11.com',
  footerEmail: '关注我们',
  footerCopyright: '© 2026 韩漫屋 版权所有',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  footerSitemap: '网站地图',
  hotTag: 'HOT',
  newTag: 'NEW',
  chapters: '话',
  ratingLabel: '评分',
  breadcrumbHome: '首页',

  categoryPageTitle: '漫画分类',
  categoryLatestTitle: '本类最新上架',
  categorySubTitle: '子分类',
  categoryTotalWorks: '部作品',
  noCategoryFound: '该分类不存在或已被移除。',

  articleAuthor: '作者',
  articleStatus: '状态',
  articleUpdateDate: '最近更新',
  articleDescription: '作品简介',
  articleRelatedTitle: '同类型推荐',
  articleReviewsTitle: '读者评论',
  articleBackToList: '返回列表',

  aboutPageTitle: '关于我们',
  aboutBrandTitle: '品牌故事',
  aboutPlatformTitle: '平台数据',
  aboutBusinessTitle: '商务合作',
  aboutContactUs: '联系我们',

  faqTitle: '常见问题',
  faqQ1: '韩漫屋的漫画都是免费的吗？',
  faqA1: '是的，韩漫屋的所有漫画作品均面向用户免费开放阅读。我们致力于为漫画爱好者提供高质量的免费阅读体验，无需付费订阅即可畅享海量韩漫资源。',
  faqQ2: '韩漫屋的漫画更新频率如何？',
  faqA2: '我们每天更新超过100部漫画的新章节，确保读者能够及时追更喜爱的作品。热门作品的更新速度尤其快，通常在原著发布后24小时内即可读到最新内容。',
  faqQ3: '如何在韩漫屋找到想看的漫画？',
  faqA3: '您可以通过首页的热门排行、最新更新模块发现热门漫画，也可以通过分类页面按题材类型浏览，还可以使用搜索功能直接查找您想看的作品名称或作者。',
  faqQ4: '韩漫屋支持哪些设备阅读？',
  faqA4: '韩漫屋采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
};